import type { MessageArgsProps } from 'antd';
import { message } from 'antd';
import { ReactNode } from 'react';

import MessageWarningIcon from '@/assets/imgs/error.svg?react';
import MessageSuccessIcon from '@/assets/imgs/success.svg?react';
import MessageInfoIcon from '@/assets/imgs/warning.svg?react';
import useApp from 'antd/es/app/useApp';
import SVGIcon from '@/components/SVGIcon';

export function messageFactory(
  msg: ReactNode,
  options: Omit<MessageArgsProps, 'content' | 'icon'> = { type: 'info' }
) {
  const { type = 'info', ...rest } = options;
  window.messageInstance[type]({
    className: 'message-overlay',
    content: msg,
    icon:
      type === 'warning' ? (
        <SVGIcon icon={<MessageWarningIcon />} style={{
          marginRight: '.1rem',
        }} />
      ) : type === 'info' ? (
        <SVGIcon icon={<MessageInfoIcon />} style={{
          marginRight: '.1rem',
        }} />
      ) : (
        <SVGIcon icon={<MessageSuccessIcon />} style={{
          marginRight: '.1rem',
        }} />
      ),
    ...rest,
  });
}

export function warning(
  msg: ReactNode,
  options?: Omit<MessageArgsProps, 'content' | 'icon' | 'type'>
) {
  messageFactory(msg, { type: 'warning', ...options });
}

export function info(
  msg: ReactNode,
  options?: Omit<MessageArgsProps, 'content' | 'icon' | 'type'>
) {
  messageFactory(msg, options);
}

export function success(
  msg: ReactNode,
  options?: Omit<MessageArgsProps, 'content' | 'icon' | 'type'>
) {
  messageFactory(msg, { type: 'success', ...options });
}

export default {
  warning,
  info,
  success,
};
